module.exports = __webpack_public_path__ + "img/swiper_3.0_3_2.154182f0.webp";